/** Select value for "Automatic": the API's `difficulty: null` (derived from
 *  the creator DNA). antd Select can't match an option whose value is null. */
export const AUTOMATIC_DIFFICULTY = "automatic";

/** Maps the stored `difficulty` to the select value and back. */
export const quizDifficultyFieldProps = {
  getValueProps: (value: unknown) => ({ value: value ?? AUTOMATIC_DIFFICULTY }),
  normalize: (value: unknown) =>
    value === AUTOMATIC_DIFFICULTY ? null : value,
};
